import { render, staticRenderFns } from "./LottiePlayer.vue?vue&type=template&id=67bf7d3c&scoped=true"
import script from "./LottiePlayer.vue?vue&type=script&lang=js"
export * from "./LottiePlayer.vue?vue&type=script&lang=js"
import style0 from "./LottiePlayer.vue?vue&type=style&index=0&id=67bf7d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf7d3c",
  null
  
)

export default component.exports